import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"
import FontAwesome from "react-fontawesome";
import UserHandler from "js/utilities/user-handler";
import CodeBlocks from "js/utilities/sdk-doc-code-blocks";
import { ZOOM_ICON } from "js/config.jsx";

import ZOOMRESTAPIENDPOINTOPTIONS from "resources/img/zoom_rest_api_endpoint_options.png";
import ZOOMSERVERSDKAUTHENTICATIONFLOW from "resources/img/zoom_server_sdk_authentication_flow.png";
import ZOOMCOMPAT from "resources/img/zoom_compat_matrix.jpg";
import SERVER_ARCHITECTURE_AND_DATA_FLOW from "resources/img/zoom_server_architecture_and_data_flow.png";
import SERVER_DEDICATE_AND_CLOUD_ARCHITECTURE from "resources/img/zoom_server_dedicated_and_cloud_architecture.png";

export default React.createClass({
  displayName: "zoom-configuration-options",
  scrollToGuide : null,
  scrollingEl : null,
  getInitialState: function() {
    var scrollToElement = initDeepLinkData(this.props);
    return {
        scrollToElement: scrollToElement
    };
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    if (this.scrollToGuide && this.scrollingEl)
      scrollTo(this.scrollingEl, this.scrollToGuide);
    this.scrollToGuide = null;

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container quick-guides-pages">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="technical-support">Technical Support</h2>
                </div>
                <p>Welcome to the technical support hub.  Use the links below to search for answers or request help from FaceTec.</p>
                <hr/>
              </section>

              <section>
                <h4 id="technical-support-resources">Technical Support Resources</h4>
                <p>Check out FAQs and Troubleshooting guides.</p>

                <div className="panel-holder">
                  <Link to="/faq" className="panel-button">
                    <FontAwesome name="question-circle" className="fontawesome-icon" />
                    <h5 className="big">FAQ</h5>
                  </Link>
                  <Link to="/glossary" className="panel-button">
                    <FontAwesome name="list" className="fontawesome-icon" />
                    <h5 className="big">Glossary</h5>
                  </Link>
                </div>
                <div className="panel-holder">
                  <Link to="/troubleshooting" className="panel-button">
                    <FontAwesome name="check" className="fontawesome-icon" />
                    <h5 className="big">Troubleshooting</h5>
                  </Link>
                  <Link to="/troubleshooting-server" className="panel-button">
                    <FontAwesome name="server" className="fontawesome-icon" />
                    <h5 className="big">Server SDK Help</h5>
                  </Link>
                </div>
              </section>

              <section>
                <h4 id="contact">Contact</h4>
                <p>Use the below pages to get in contact with FaceTec about questions or issues.</p>

                <div className="panel-holder">
                  <Link to="/general-questions" className="panel-button">
                    <FontAwesome name="question" className="fontawesome-icon" />
                    <h5 className="big">General Questions</h5>
                  </Link>
                  <Link to="/support" className="panel-button">
                    <FontAwesome name="bug" className="fontawesome-icon" />
                    <h5 className="big">Send Issue Report by Email</h5>
                  </Link>
                </div>
                <div className="panel-holder">
                  <Link to="/quote" className="panel-button">
                    <FontAwesome name="dollar" className="fontawesome-icon" />
                    <h5 className="big">Request a Pricing Quote</h5>
                  </Link>
                </div>
              </section>

              <SDKSidebar menuType="main" title="Technical Support"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/technical-support.jsx